// extracted by mini-css-extract-plugin
export default {"Counter":"Counter_Counter__-oSsJ","decrement_btn":"Counter_decrement_btn__iv2mS","increment_btn":"Counter_increment_btn__uUUZr","product_count":"Counter_product_count__rhfDv"};